import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IUserInfo } from '../../models/IUserInfo';
import { IShareAction } from './GetSharedWithMeRequest';
import { Request } from './Request';

export interface ISharedVersion {
  id: string;
  contentType: string;
  name?: string; // this is required if content type is custom view
  isHidden?: boolean; // this is required if content type is custom view
  url?: string; // this is required if content type is custom view
}

export interface IGetShareActivityParams extends IGetItemsParams {
  viewId: string;
}

export interface IGetShareActivityResult extends IGetItemsResult {
  viewOrCustomizedViews: ISharedVersion[];
  deletedSharers: IUserInfo[];
  sharers: IUserInfo[];
  shareActions: IShareAction[];
}

export class GetShareActivityRequest extends Request<IGetShareActivityParams, IGetShareActivityResult> {
  constructor(params: IGetShareActivityParams) {
    super('getShareActivity', params);
  }
}
